
import { Mixins, VModel, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import { deserialise } from 'kitsu-core'

@Component({
    name: 'NestedDraggable',
})
export default class NestedDraggable extends Mixins<MixinInterface>() {
    @VModel({
        default: () => {
            return {}
        },
    })
    item!: Record<string, any>
    @Prop({ default: 'project' }) module!: string
    @Prop({ required: true }) updateItem!: Function
    @Prop({ required: true }) postItem!: Function
    @Prop({ default: true }) disabled!: boolean

    // Edit
    editModeOn = false
    editLoading = false
    newName = ''

    initiateEdit() {
        if (!this.item) return
        this.newName = this.item.name
        this.editModeOn = true
        this.$nextTick(() => {
            if (this.$refs.editNameRef) {
                this.$refs.editNameRef.focus()
            }
        })
    }

    cancelEdit() {
        if (!this.item) return
        this.newName = this.item.name
        this.editModeOn = false
    }

    async saveItem() {
        if (this.newName.length < 2) return

        try {
            this.editLoading = true
            const payload = {
                id: this.item?.id,
                type: this.item?.type,
                name: this.newName,
            }
            const data = await this.updateItem(payload)

            this.item = {
                ...deserialise(data).data,
                children: this.item.children,
            }
            this.editModeOn = false
        } finally {
            this.editLoading = false
        }
    }

    // Archive
    archiveLoading = false

    async archiveItem() {
        if (!this.item) return

        try {
            this.archiveLoading = true
            const payload = {
                id: this.item?.id,
                type: this.item?.type,
                isActive: !this.item.isActive,
            }
            const data = await this.updateItem(payload)

            this.item = {
                ...deserialise(data).data,
                children: this.item.children,
            }
        } finally {
            this.archiveLoading = false
        }
    }

    //Child item
    childModeOn = false
    childLoading = false
    childName = ''

    initiateChild() {
        this.childName = ''
        this.childModeOn = true
        this.$nextTick(() => {
            this.$nextTick(() => {
                if (this.$refs.childNameRef) {
                    this.$refs.childNameRef.focus()
                }
            })
        })
    }

    async createChild() {
        if (this.childName.length < 2) return

        try {
            this.childLoading = true

            const payload = {
                type: this.item?.type,
                name: this.childName,
                parent: {
                    data: {
                        id: this.item?.id,
                        type: this.item?.type,
                    },
                },
                project: {
                    data: {
                        id: this.currentProjectId,
                        type: 'project',
                    },
                },
            }
            const data = await this.postItem(payload)
            this.item.children?.push(deserialise(data).data)

            this.childName = ''
            this.childModeOn = false
        } finally {
            this.childLoading = false
        }
    }
}
